import { OESTRA_QUIZ_ENTRY_HREF } from "~/constants/oestraLandingPages";
import { APP_ROUTES } from "~/constants/appRoutes";
import { QUIZ_ROUTES } from "~/constants/quizRoutes";

export type Product = {
    imageUrl: string;
    imageHoverUrl: string;
    imageAlt: string;
    name: string;
    title: string;
    href: string;
    analyticEvent: {
        click_text: string;
        product_name: string;
    };
};

export const PRODUCTS = [
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1786433871/design_system/oestra_rnieuz.webp",
        imageHoverUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1788807190/new_design/CTA_Card_uneony.webp",
        imageAlt: "Oestra® hormone cream jar",
        name: "Oestra®",
        title: "Treat Hormonal Imbalance",
        href: OESTRA_QUIZ_ENTRY_HREF,
        analyticEvent: {
            click_text: "Treat Hormonal Imbalance",
            product_name: "oestra",
        },
    },
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1786433871/design_system/libida_rxthtj.webp",
        imageHoverUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1788807190/new_design/CTA_Card_1_touwvz.webp",
        imageAlt: "Libida® sublingual tablets",
        name: "Libida®",
        title: "Have Better Sex",
        href: QUIZ_ROUTES.LIBIDA,
        analyticEvent: {
            click_text: "Have Better Sex",
            product_name: "libida",
        },
    },
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1786433872/design_system/bdy-matched_e4rrej.webp",
        imageHoverUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1788807190/new_design/CTA_Card_2_rot1pa.webp",
        imageAlt: "BodyMatched® anti-aging face cream",
        name: "BodyMatched®",
        title: "Treat Aging + Dull Skin",
        href: APP_ROUTES.PQP_ANTI_AGING_FACE_CREAM,
        analyticEvent: {
            click_text: "Treat Aging + Dull Skin",
            product_name: "anti-aging face cream",
        },
    },
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1786433871/design_system/nad_zaj51u.webp",
        imageHoverUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1788807190/new_design/CTA_Card_3_emsozj.webp",
        imageAlt: "NAD+ longevity capsules",
        name: "NAD+",
        title: "Fuel Energy + Longevity",
        href: QUIZ_ROUTES.NAD,
        analyticEvent: {
            click_text: "Fuel Energy + Longevity",
            product_name: "nad+",
        },
    },
] as const satisfies readonly Product[];
